$(document).ready(function () {
  // show_content
  // $("body").on("click", ".show-content", function () {
  //   var t_element = $("." + $(this).data("toggle"));
  //   t_element.toggleClass("active");
  //   $(this).toggleClass("active");
  // });
  // toggle next
  $("body").on("click", ".toggle-next", function () {
    var t_element = $(this).next(".toggle-content");
    $(this).toggleClass("active");
    t_element.toggleClass("active");
  });

  $(".faq").on("click", ".faq-q", function () {
    $(this).toggleClass("open");
  });
});
